import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
const ProtectedRoute = ({ children, requiredRole }) => {
const { user } = useContext(UserContext)                                ;
if (!user) {
return <Navigate to="/" />                                              ;
}
if (requiredRole) {
const requiredRoles = requiredRole.split('|');
if (!requiredRoles.includes(user.role)) {
return <Navigate to="/unauthorized" />                                  ;
}
}
return children                                                         ;
}                                                                       ;
export default ProtectedRoute                                           ;
